import { render, staticRenderFns } from "./succeed.vue?vue&type=template&id=31606b8a&scoped=true&"
import script from "./succeed.vue?vue&type=script&lang=js&"
export * from "./succeed.vue?vue&type=script&lang=js&"
import style0 from "./succeed.vue?vue&type=style&index=0&id=31606b8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31606b8a",
  null
  
)

export default component.exports